import { EDUCATION_SCOPE_KEY } from '../../education/Education';

export default function shiftForEducation(Authentication, sdk) {
  'ngInject';

  /**
   * This directive probably violates several programming patterns
   * thus feels "kinda hacky" but IMO it's too much to
   * apply it properly in every template where a "shift" occurs
   * which is at least 4 places. Hence it hooks on a class. The class
   * that already exits on all shifts: "shift". Thanks to that we can
   * completely plug it in and out without any modifications in the templates
   */
  return {
    restrict: 'C',
    link($scope, $element) {
      $element.data(EDUCATION_SCOPE_KEY, $scope);
      const { EVENT_STATUS } = sdk('constants');

      if (
        $scope.event &&
        $scope.ctrl &&
        $scope.ctrl &&
        $scope.event.id === $scope.ctrl.recentlyCreatedEventId
      ) {
        if (!$scope.authentication) {
          $scope.authentication = Authentication;
        }

        if ($scope.event.status === EVENT_STATUS.PLANNING) {
          $element.addClass('education-recently-created-shift');
          $element.attr('education-parent-width', true);
        }
      }
    },
  };
}
